export const PHONE_DISPLAY = "07908 659005";
export const PHONE_TEL = "+447908659005";
export const WHATSAPP_URL = "https://wa.me/447908659005?text=Hi%20Matlock%20Groundworks%2C%20I%27d%20like%20a%20free%20quote.";
export const HERO_IMAGE = "https://images.unsplash.com/photo-1630288214173-a119cf823388?q=80&w=2400&auto=format&fit=crop";
